import { Colors } from '@brg/ui';
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import {getWidthWithRatio} from "../../helpers/getSizeWithRatio";

export const SummaryTableInfo = styled.div<{
    mobile?: boolean
    mb?: string
}>`
    color: ${p => p.theme.sendGift.text};
    align-self: flex-start;
    display: flex;
    // margin-bottom: ${p => p.mb ? p.mb : "32px"};
    text-align: start;
    max-width: calc(100vw - 136px);

    @media (max-width: ${LayoutConst.screen.l}px) {
        max-width: 100vw;
    }
`

export const ProductNameWrapper = styled.div`
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
        line-height: 20px
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 17px;
        line-height: 22px
    }
`

export const SummaryInfoGrid = styled.div`
    // display: grid;
    // grid-template-columns: 100px 1fr;
    // column-gap: 32px;
    display: flex;
    flex-direction: column;
    row-gap: 8px;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        column-gap: 4px;
    }
`

export const SummaryTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 100%;
`

export const GridTextRow = styled.div<{isCard?:boolean}>`
    display: grid;
    column-gap: 12px;
    row-gap: 10px;
    grid-template-columns: 170px 1fr;
    ${p => p.isCard && css`
        grid-template-columns: 1fr 1fr;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        grid-template-columns: 150px 1fr;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        grid-template-columns: 135px 1fr;
    }
`

const commonStylesInfoText = css`
    font-family: Inter;
    font-style: normal;
    color: ${Colors.galBlack47};
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

export const LeftGridText = styled.div<{receiveGift?:boolean}>`
    ${commonStylesInfoText};
    font-weight: 400;

    ${p => p?.receiveGift && css`
        word-break: break-word;

        &::first-letter {
            text-transform: uppercase;
    `};
`

export const RightGridText = styled.div`
    ${commonStylesInfoText};
    font-weight: 600;
    word-break: break-word;

    ::first-letter {
        text-transform: uppercase;
    }
    @media (max-width: ${LayoutConst.screen.s + 1}px) {
        font-weight: 600;
    }
}
`

export const CalendarCards = styled.div`
    display: flex;
    max-width: 100%;
    // overflow: scroll;
    scrollbar-width: none;
    gap: 8px;
    //margin-top: 8px;
    &::-webkit-scrollbar {
        display: none;
    }

    height: 100px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 80px;
    }
`

export const CheckoutCardWrapper = styled.div<{
    isHorizontal: boolean;
    height: number;
}>`
    height: ${p => p.height}px;
    width: ${p => getWidthWithRatio(p.height, p.isHorizontal)}px;
    background: white;
    // margin-right: 8px;
`

export const CardsExpand = styled.div<any>`
    svg {
        margin-left: 8px;
        transform: rotate(${p => p.expanded ? 0 : 180}deg);
    }
`

export const CopySuccessTableValues = styled.div`
    ${commonStylesInfoText};
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    display: flex;
    align-items: flex-start;
    overflow: hidden!important;
    text-overflow: ellipsis!important;
    flex-direction: column;
    letter-spacing: -0.34px;
    gap: 4px;
    width: 100%;
    max-width: 200px;
    white-space: normal;
    word-break: break-word;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        max-width: 138px;
    };

    @media (max-width: ${LayoutConst.screen.l}px) {
        max-width: 174px;
    };

    @media (max-width: ${LayoutConst.screen.s + 1}px) {
        max-width: 100%;
    }
`;

export const CopySuccessTableValue = styled.div`
    display: flex;
    align-items: center;
    
    > div {
        width: 13px;
        height: 13px;
    }
`;
import { Colors } from '@brg/ui';
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import {getWidthWithRatio} from "../../helpers/getSizeWithRatio";

export const SummaryTableInfo = styled.div<{
    mobile?: boolean
    mb?: string
}>`
    color: ${p => p.theme.sendGift.text};
    align-self: flex-start;
    display: flex;
    // margin-bottom: ${p => p.mb ? p.mb : "32px"};
    text-align: start;
    max-width: calc(100vw - 136px);

    @media (max-width: ${LayoutConst.screen.l}px) {
        max-width: 100vw;
    }
`

export const ProductNameWrapper = styled.div`
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
        line-height: 20px
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 17px;
        line-height: 22px
    }
`

export const SummaryInfoGrid = styled.div`
    // display: grid;
    // grid-template-columns: 100px 1fr;
    // column-gap: 32px;
    display: flex;
    flex-direction: column;
    row-gap: 8px;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        column-gap: 4px;
    }
`

export const SummaryTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 100%;
`

export const GridTextRow = styled.div<{isCard?:boolean}>`
    display: grid;
    column-gap: 12px;
    row-gap: 10px;
    grid-template-columns: 170px 1fr;
    ${p => p.isCard && css`
        grid-template-columns: 1fr 1fr;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        grid-template-columns: 150px 1fr;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        grid-template-columns: 135px 1fr;
    }
`

const commonStylesInfoText = css`
    font-family: Inter;
    font-style: normal;
    color: ${Colors.galBlack47};
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

export const LeftGridText = styled.div<{receiveGift?:boolean}>`
    ${commonStylesInfoText};
    font-weight: 400;

    ${p => p?.receiveGift && css`
        word-break: break-word;

        &::first-letter {
            text-transform: uppercase;
    `};
`

export const RightGridText = styled.div`
    ${commonStylesInfoText};
    font-weight: 600;
    word-break: break-word;

    ::first-letter {
        text-transform: uppercase;
    }
    @media (max-width: ${LayoutConst.screen.s + 1}px) {
        font-weight: 600;
    }
}
`

export const CalendarCards = styled.div`
    display: flex;
    max-width: 100%;
    // overflow: scroll;
    scrollbar-width: none;
    gap: 8px;
    //margin-top: 8px;
    &::-webkit-scrollbar {
        display: none;
    }

    height: 100px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 80px;
    }
`

export const CheckoutCardWrapper = styled.div<{
    isHorizontal: boolean;
    height: number;
}>`
    height: ${p => p.height}px;
    width: ${p => getWidthWithRatio(p.height, p.isHorizontal)}px;
    background: white;
    // margin-right: 8px;
`

export const CardsExpand = styled.div<any>`
    svg {
        margin-left: 8px;
        transform: rotate(${p => p.expanded ? 0 : 180}deg);
    }
`

export const CopySuccessTableValues = styled.div`
    ${commonStylesInfoText};
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    display: flex;
    align-items: flex-start;
    overflow: hidden!important;
    text-overflow: ellipsis!important;
    flex-direction: column;
    letter-spacing: -0.34px;
    gap: 4px;
    width: 100%;
    max-width: 200px;
    white-space: normal;
    word-break: break-word;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        max-width: 138px;
    };

    @media (max-width: ${LayoutConst.screen.l}px) {
        max-width: 174px;
    };

    @media (max-width: ${LayoutConst.screen.s + 1}px) {
        max-width: 100%;
    }
`;

export const CopySuccessTableValue = styled.div`
    display: flex;
    align-items: center;
    
    > div {
        width: 13px;
        height: 13px;
    }
`;
